import { useNavigate, useParams } from "react-router";
import * as webHelpers from "../../../../../helpers/WebHelpers";
import { PageContainer, PortalPageType } from "../../../../components/container";
import { useEffect, useState } from "react";
import { IJobsheet } from "../../../../../interfaces/jobsheets/IJobsheet";
import { GridItem, Editable, EditableInput, EditableTextarea, EditablePreview, Button, Select, Tabs, TabList, Tab, TabPanels, TabPanel, Avatar, Flex, Text, HStack, VStack, Divider, Stack, Box, Alert, AlertIcon, AlertTitle, Heading, Input, InputGroup, InputLeftAddon, InputRightElement, Badge, Image, Grid, Checkbox, AlertDescription, Popover, PopoverTrigger, PopoverContent, PopoverArrow, PopoverBody, Link, useToast } from "@chakra-ui/react";
import loadingGif from "../../../assets/loadingIcon.gif"
import { DescriptionOfWorks } from "../DescriptionOfWorks";
import { Pricing } from "../Pricing";
import { IWipLine, WiplineStatus } from "../../../../../interfaces/jobsheets/IWipline";
import { AppointmentDetails } from "../AppointmentOverview";
import { sign } from "crypto";
import { ErrorBoundary } from "react-error-boundary";
import { isErrored } from "stream";
import { GoBriefcase, GoCalendar, GoWatch } from "react-icons/go";
import { MdHelpOutline, MdOutlineTimer, MdPinDrop } from "react-icons/md";
import { GetDateTimeFromTimestamp, GetDateTimeFromTimestampRounded, GetLongDateFormat } from "../../../../../helpers/DateTimeHelpers";
import { setegid } from "process";
import { AlternativeWorks } from "../AlternativeWorks";

export const InvoiceConfirmation = ({jobsheet, wiplines, completeCallback}: {jobsheet: IJobsheet, wiplines: IWipLine[], completeCallback: () => void}) => {
    const toast = useToast();
    
    const [isAgreed, setIsAgreed] = useState<boolean>(false);
    const [signee, setSignee] = useState<string | undefined>(undefined);
    const [working, setWorking] = useState<boolean>(false);

    const [isErrored, setError] = useState<boolean>(false);
    const [errorMsg, setErrorMsg] = useState<string>("");

    const confirm = () => {
        setError(false);

        //Check valid
        if (isAgreed === false || signee === undefined || signee === "") {
            setErrorMsg("Make sure you checked the box to confirm and entered your name");
            setError(true);
            return;
        }

        console.log(jobsheet.appointment);

        setWorking(true);
        //Reopen appointment
        webHelpers.postAsync("/api/sales/work/releaseinvoice", { job: jobsheet.id, signee: signee }).then(res => {
            toast({
                title: "Invoice confirmed",
                description: "The invoice has been successfully confirmed",
                status: "success",
                duration: 8000,
                isClosable: true
            });

            completeCallback();
            setWorking(false);
        }).catch(() =>{
            setErrorMsg("Unable to confirm invoice. Please refresh and try again or contact our team.");
            setError(true);
        });
    }



    //@ts-ignore
    function ErrorFallback({ error, resetErrorBoundary }) {
        return (
            <>
                <div role="alert">
                    <p> Something went wrong:</p>
                    <pre>{error.message}</pre>
                    <button type="submit" onClick={resetErrorBoundary}>Try again</button>
                </div>
            </>
        );
    }

    return (
        <ErrorBoundary FallbackComponent={ErrorFallback}>
            <Flex direction='column' fontSize={{ base: "md", lg: "lg" }} mt={5}>
                <Heading textAlign='center' mb={5} size='lg'>Invoice Confirmation</Heading>

                {
                    jobsheet !== undefined &&
                    <>
                        <Flex direction='column' rowGap={3}>                                
                            <Text as='b' align='center'>Please read the information below and ensure it is correct.</Text>
                            <Text align='center'>If any of the details are wrong or if the address shown is not the correct invoicing address, please send us an email: <Link color="blue" href="mailto:sales@able-group.co.uk">sales@able-group.co.uk</Link></Text>
                            <Text align='center'>Otherwise, you may confirm the invoice at the bottom of this page.</Text>

                            <AppointmentDetails jobsheet={jobsheet} showBilling={true}/>

                            <ErrorBoundary FallbackComponent={ErrorFallback}>
                                <DescriptionOfWorks jobsheet={jobsheet} appointmentWipLines={wiplines} showCleardownPlan={false}/>
                                <AlternativeWorks jobsheet={jobsheet}/>
                            </ErrorBoundary>

                            <Pricing jobsheet={jobsheet}/>
                        </Flex>

                        <Flex direction='column' rowGap={4} mt={8}>
                            <Text as='b' align='center'>Payment for any works carried out should be made on receipt of the invoice. Please note there are no credit facilities.</Text>

                            <Checkbox isChecked={isAgreed} onChange={(e) => setIsAgreed(e.target.checked)}>I confirm that the above details are correct</Checkbox>
                            <Input placeholder="Enter your name" value={signee} onChange={e => setSignee(e.target.value)}/>

                            {isErrored &&
                                <Alert status="error">
                                    <AlertIcon/>
                                    <AlertTitle>Error</AlertTitle>
                                    <AlertDescription>{errorMsg}</AlertDescription>
                                </Alert>
                            }

                            <Button colorScheme="green" onClick={confirm} isLoading={working}>Confirm</Button>
                        </Flex>
                    </>  
                }
            </Flex>
        </ErrorBoundary>
    )
}